import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import DialogHeader from "../components/DialogHeader"

export default function ConfirmDeletePerkDialog({ open, onClose, perk }) {
  const [isLoading, setIsLoading] = useState(false)
  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleDeleteButtonClicked() {
    setIsLoading(true)
    axios
      .delete(`/crm/api/custom-perk/${perk.id}/`)
      .then(() => onClose(true))
      .finally(() => setIsLoading(false))
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title={`Delete ${perk?.title}`} onClose={handleSoftClose} />
      <DialogContent>
        <Typography variant="body1">
          This will remove the perk from all proposals.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isLoading}
          onClick={handleDeleteButtonClicked}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
